export function signupSourceLabel(source) {
  if (source === 'footer') return 'Footer';
  if (source === 'popup') return 'Marketing pop-up';
  if (source === 'about') return 'Pagina Over ons';
  if (source === 'unknown') return 'Onbekend';
  return source || '—';
}
